import { Sparkles } from "lucide-react";
import { CheckIcon } from "./Ui";

const STATS = [
  "Transparent pricing no hidden fees",
];

export function LeftPanel({ reviewIndex }) {
  return (
    <div className="flex flex-col h-full justify-between py-10">

     

      <div>

        {/* Heading */}
        <h1 
          className="font-bold text-[#000000] leading-tight mb-6"
          style={{ 
            fontSize: "clamp(28px, 5vw, 48px)",
            fontWeight: "700",
            lineHeight: "1.3"
          }}
        >
          How Much Does Business Setup in{" "}
          <span className="text-[#000000]">Dubai Cost?</span>
        </h1>

        {/* Subtext */}
        <p 
          className="text-gray-600 mb-8 sm:mb-10"
          style={{ 
            fontSize: "clamp(14px, 1.2vw, 16px)",
            lineHeight: "1.6"
          }}
        >
          That depends on your business activity, location (free zone or mainland),
          number of visas, and shareholders. Based on thousands of successful setups,
          our smart calculator gives you a fast and accurate estimate.
        </p>

        {/* Stats */}
        <ul className="space-y-3 sm:space-y-4 mb-8 sm:mb-10">
          {STATS.map((stat) => (
            <li key={stat} className="flex items-start gap-3">
              <span className="flex-shrink-0 mt-0.5 w-5 h-5 rounded-full bg-[#B8893A] flex items-center justify-center">
                
              </span>
              <span className="text-sm sm:text-base text-gray-700 font-medium leading-relaxed">
                {stat}
              </span>
            </li>
          ))}
        </ul>

      </div>

     {/* CTA Buttons */}
<div className="flex flex-col sm:flex-row gap-3 pt-2">

  <a
    href="https://wa.me/971507987470?text=Hello%20AWS%20Businessmen%20Services%2C%20I%20need%20a%20consultation"
    target="_blank"
    rel="noreferrer"
    className="
      w-full sm:w-auto 
      px-4 py-2.5 sm:px-6 sm:py-3 
      rounded-xl 
      bg-[#B8893A] text-white 
      font-semibold 
      text-xs sm:text-sm md:text-base 
      shadow-md 
      hover:shadow-xl hover:bg-[#a3772f] 
      hover:-translate-y-0.5 
      transition-all duration-300
    "
  >
    Get a Free Consultation
  </a>

  <a
    href="https://wa.me/971507987470?text=Hello%20AWS%20Businessmen%20Services%2C%20I%20need%20an%20instant%20estimate"
    target="_blank"
    rel="noreferrer"
    className="
      w-full sm:w-auto 
      px-4 py-2.5 sm:px-6 sm:py-3 
      rounded-xl 
      border border-[#B8893A] 
      text-[#B8893A] 
      font-semibold 
      text-xs sm:text-sm md:text-base 
      hover:bg-[#B8893A]/10 
      hover:-translate-y-0.5 
      transition-all duration-300
    "
  >
    Get Instant Estimate
  </a>

</div>

    </div>
  );
}
